export default "__VITE_ASSET__ccrOjrE2__"